import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

const DeleteConfirmation = ({open, closeDelete, handleDelete, title, deleteBtn = "Delete", content = ''}) => {

  return (
    <React.Fragment>
      <Dialog open={open} onClose={closeDelete}>
        <DialogTitle>{title}</DialogTitle>
        {content.length > 0 && 
            <DialogContent dividers>
                {content}
            </DialogContent>
        }
        <DialogActions>
          <Button onClick={closeDelete}>Cancel</Button>
          <Button onClick={handleDelete}>{deleteBtn}</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default DeleteConfirmation;
